import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-docx-viewer',
  templateUrl: './docx-viewer.component.html',
  styleUrls: ['./docx-viewer.component.scss']
})
export class DocxViewerComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() blob: Blob | null = null;

  @ViewChild('container', { static: true }) container!: ElementRef<HTMLDivElement>;

  loading = false;
  error: string | null = null;

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blob'] && this.container) {
      this.render();
    }
  }

  ngOnDestroy(): void {
    if (this.container?.nativeElement) {
      this.container.nativeElement.innerHTML = '';
    }
  }

  private async render(): Promise<void> {
    if (!this.blob || !this.container?.nativeElement) return;
    this.loading = true;
    this.error = null;
    this.container.nativeElement.innerHTML = '';
    try {
      const mod = await import('docx-preview');
      await mod.renderAsync(this.blob, this.container.nativeElement, undefined, {
        inWrapper: true,
        ignoreLastRenderedPageBreak: false,
        breakPages: true,
        experimental: false
      });
    } catch (e: any) {
      this.error = e?.message ?? 'No se pudo previsualizar el documento.';
    } finally {
      this.loading = false;
    }
  }
}
